const Form028EN = {
    stepName: {
        ImportantNotes: "Important Notes",
        ApplicationInfo: "Application Information",
        Confirmation: "Confirmation",
    },
    label: {
        teacherInfo: "Teacher Registration",
        schoolInfo: "School Information",
        chineseName: "Name in Chinese",
        englishName: "Name in English",
        title: "Mr/Ms",
        hkid: "HKID Card No.",
        permitNo: "Teacher Registration / Teaching Permit No.",
        schoolChop: "School Chop",
        // schoolName: "Name of School and School Chop",
        schoolName: "Name of School",
        schoolNumber: "School Number",
        signature: "Signature of Applicant",
        principal: "Signature of Supervisor/Principal",
        applicantName: "Name of Applicant",
        supervisorName: "Name of *Supervisor/Principal",
        contactNo: "Applicant's Contact No",
        approverEmailAddress: "Email Address of Applicant",
        date: "Date",
        //dates: "日期",
        //edbDate: "日期",
        titleOption: {
            Mr: "Mr",
            Ms: "Ms",
        },
        teacherNoOption: {
            R: "Registered Teacher No.",
            P: "Permitted Teacher No.",
            N: "N/A",
        },
        errTeacherNoR: "Registered Teacher No.",
        errTeacherNoP: "Permitted Teacher No.",
        note: "Notes for Completing the Application Form for Enquiring Teacher Registration Information",
        info1: "*",
        info2: " (Name in Chinese: ",
        info3: ") HKID Card No.: ",
        info4: " Teacher Registration / Teaching Permit No.: ",
        info5: " (if applicable) apply for and authorize the Education Bureau to release the information related to my teacher registration to the school Supervisor/Principal of the following school, including whether the Education Bureau has ever refused my teacher registration application/permission to teach, cancelled my teacher registration/permit to teach or whether any reprimand/warning/advisory letter has been issued related to my teacher registration.",

        //FormB
        SchoolEmail:"School's Email",
        fromSchoolSupervisorName: "Name of Supervisor/Principal",
        fromSchoolSchoolName: "Name of School",
        fromSchoolSchoolNumber: "Number of School",
        fromSchoolAddress: "School Address",
        fromSchoolFaxNumber: "Fax No.",
        statement:
            "I have read, understood and agreed to the above terms and conditions.",
        termsConditions:
            'I understand Supervisor/Principal and teachers need to have an "iAM Smart+" account to submit the application.',
    },
    edbNotes: {
        title: "To be completed by EDB officer",
        label1: "Dear Supervisor/Principal",
        label2: "According to our record, the teacher registration information of the above applicant is as follows:",
        symbolStep: [
            { step: "(1)(i)" },
            { step: "(1)(ii)" },
            { step: "(1)(iii)" },
            { step: "(2)(i)" },
            { step: "(2)(ii)" },
            { step: "(2)(iii)" },
            { step: "(3)(i)" },
            { step: "(3)(ii)" },
            { step: "(4)" },
        ],
        option: {
            option1: "No teacher registration record has been found in EDB.",
            option2: "The above applicant is a registered teacher.",
            option3:
                "The above applicant is / was a permitted teacher.<br />(A permit to teach shall be deemed to be cancelled if the permitted teacher ceases to be  employed in the school specified in the permit.）",
            option4:
                "The above applicant has never been refused to be registered as a teacher / refused permission to teach or had the teacher registration / permit to teach cancelled.",
            option5:
                "The above applicant has previously been refused to be registered as a teacher/refused permission to teach on __________________.",
            option6:
                "The teacher registration / permit to teach of the above applicant has been cancelled on ________________.",
            option7:
                "No reprimand / warning / advisory letter has been issued to the above applicant regarding his teacher  registration. ",
            option8:
                "A *reprimand / warning / advisory letter was issued on __________________ regarding the teacher registration of the above applicant<sup> Note (3)</sup>.",
            option9:
                "ˆThis Bureau is reviewing the registration status of the above applicant.",
        },
        label3: "Schools are reminded to observe the provisions of the Personal Data (Privacy) Ordinance when handling the applicants’ personal data. The above information should be used for processing the job applications and assessing the suitability of candidates for the job only. Should you have any enquiries, please contact the Teacher Registration Team of EDB at 3467 8282.",
        label4: "ˆIt should be noted that by reviewing the registration status of a teacher, EDB may issue a reprimand / warning / advisory letter or cancel his / her teacher registration / permit to teach.",
    },
    notes: {
        colon: [
            {
                text: "(1)",
            },
            {
                text: "(2)",
            },
            {
                text: "(3)",
            },
            {
                text: "(4)",
            },
        ],
        note: [
            {
                text: "EDB will only accept applications for releasing the teacher registration information to schools. Applications for releasing the teacher registration information to individuals or other organizations will not be processed.",
            },
            {
                text: "The school should seek the proposed teacher's consent to apply to EDB for the release of teacher registration information to the school. Application forms can be downloaded at EDB website: <a href='http://edb.gov.hk', target='_blank'>www.edb.gov.hk</a>.",
            },
            {
                text: "Schools are reminded that the relevant information pertaining to any advisory / warning / reprimand letter issued to the proposed teacher, which is premised on his/her convictions for which he / she is not obliged to disclose under section 2(1) of the Rehabilitation of Offenders Ordinance (Cap. 297), will not be disclosed.",
            },
            {
                text: "Applicants can file in duly completed application forms in person, by mail or by fax. The address is as follows:",
            },
        ],
        note3: [
            { text: "Teacher Registration Team Education Bureau" },
            { text: "2/F, Trade and Industry Tower" },
            { text: "3 Concorde Road Kowloon" },
            {
                text: "(Office Hour：Mon to Fri :8:30 am -1:00 pm, 2:00 pm to 6:00 pm",
            },
            { text: "Saturdays, Sundays & Public holidays : Close)" },
            {
                text: "For further enquiries, please contact Teacher Registration Team",
            },
            {
                text: "Tel.:3467 8282",
            },
            {
                text: "Fax :2520 0065",
            },
        ],
    },
    submittedDialog: {
        text1: "You have successfully submitted the form. Please note that this form is not yet received by EDB. It is pending the teacher's completion of the form.",
        multiLayerSubmitMsg:
            "You are about to be redirected to fill in the application.",
    },
    approval: {
        noteCon1: "Review, and complete the form by pressing ‘Submit’.",
        noteCon2: "Review, complete and sign the form by pressing ‘Submit’.",
    },
    errorMsg: {
        faxDigit: "Fax no. must contain 8 digits.",
    },
    // reply: "Return to School",
};
export default Form028EN;
